/**
 * Runtime array of all keys in `Callbacks`, kept in sync with the type above.
 * Used by the React SDK to pre-initialize listener maps for callback composition.
 */
export const CALLBACK_KEYS = [
    "onConnect",
    "onDisconnect",
    "onError",
    "onMessage",
    "onAudio",
    "onModeChange",
    "onStatusChange",
    "onCanSendFeedbackChange",
    "onUnhandledClientToolCall",
    "onVadScore",
    "onMCPToolCall",
    "onMCPConnectionStatus",
    "onAgentToolRequest",
    "onAgentToolResponse",
    "onConversationMetadata",
    "onAsrInitiationMetadata",
    "onInterruption",
    "onAgentResponseCorrection",
    "onAgentChatResponsePart",
    "onAudioAlignment",
    "onGuardrailTriggered",
    "onDebug",
];
